/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";

import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import { useStyles } from "./styles";

const Row = ({ children, ...rest }: any) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      style={{ display: "flex", justifyContent: "space-between" }}
      className={classes.rowContainer}
      {...rest}
    >
      {children}
    </Grid>
  );
};

const RowItem = ({ children, className, ...rest }: any) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid
      item
      className={className ? `${className}  ${classes.item}` : classes.item}
      {...rest}
    >
      <Box mb={theme.spacing(0.55)} className={classes.input} component={"div"}>
        {children}
      </Box>
    </Grid>
  );
};

export { RowItem, Row };
